module.exports = __webpack_public_path__ + "img/review-request-man.c249d95a.svg";